module.exports = __webpack_public_path__ + "static/media/onboarding-sitebuilder-v2.9803c0fb.webm";